<template>
  <div class="main_right elevator">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">电梯名称：</span>
        </div>
        <el-input v-model="name" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">楼栋名称：</span>
        </div>
        <el-select v-model="buildingCode" size="small" style="width: 280px">
          <el-option v-for="item in buildingList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">通行属性：</span>
        </div>
        <el-select v-model="passAttribute" size="small" style="width: 280px">
          <el-option v-for="item in passAttributeList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">关联设备：</span>
        </div>
        <el-select v-model="relateGatewayCode" size="small" style="width: 280px">
          <el-option v-for="item in relateGatewayList" :key="item.deviceCode"
                     :label="item.deviceName" :value="item.deviceCode">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">场景：</span>
        </div>
        <el-select v-model="scene" size="small" style="width: 280px">
          <el-option v-for="item in sceneList" :key="item.code"
                     :label="item.name" :value="item.code">
          </el-option>
        </el-select>
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">起始楼层：</span>
        </div>
        <el-input-number v-model="startLevel" controls-position="right" @change="changeStartLevel" :min="-10" :max="endLevel" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">结束楼层：</span>
        </div>
        <el-input-number v-model="endLevel" controls-position="right" @change="changeEndLevel" :min="startLevel" :max="300" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <span class="line-text">是否启用梯控：</span>
        </div>
        <div style="width: 220px;line-height: 32px;display: inline-block;">
          <el-switch
            v-model="useLift"
            active-text="是"
            inactive-text="否">
          </el-switch>
        </div>
      </div>

      <div class="form-line" v-if="useLift">
        <div class="textBox">
          <span class="line-text">控制类型：</span>
        </div>
        <div style="width: 220px;line-height: 32px;display: inline-block;">
          <el-switch
            v-model="controlTypeControl"
            active-text="自动"
            inactive-text="手动">
          </el-switch>
        </div>
      </div>

      <div class="form-line" v-if="useLift && scene === '2'">
        <div class="textBox">
          <span class="line-text">是否按层控制：</span>
        </div>
        <div style="width: 220px;line-height: 32px;display: inline-block;">
          <el-switch
            v-model="authControl"
            active-text="是"
            inactive-text="否">
          </el-switch>
        </div>
      </div>

      <div class="form-line" style="display: flex;justify-content: flex-start;align-items: top;" v-if="useLift && scene === '2'">
        <div class="textBox">
          <b class="red"></b>
          <span class="line-text">免控楼层：</span>
        </div>
        <div style="display: inline-block;width: 500px;">
          <el-checkbox-group v-model="checkedLevels" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="level in levelList" :label="level" :key="level">{{level}}</el-checkbox>
          </el-checkbox-group>
        </div>
      </div>

      <!--<div class="form-line" v-if="hasResponsiblePerson">-->
      <!--<div class="textBox">-->
      <!--<b class="red">*</b>-->
      <!--<span class="line-text">责任人：</span>-->
      <!--</div>-->
      <!--<el-select v-model="responsiblePerson"-->
      <!--filterable-->
      <!--remote-->
      <!--reserve-keyword-->
      <!--size="small" style="width: 280px"-->
      <!--:remote-method="remoteMethod"-->
      <!--placeholder="请输入关键词查询">-->
      <!--<el-option v-for="item in responsiblePersonList" :key="item._value"-->
      <!--:label="item._label" :value="item._value">-->
      <!--</el-option>-->
      <!--</el-select>-->
      <!--<span v-html="responsiblePersonVer"></span>-->
      <!--</div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="strategyCenter" />
      </div>

    </form>
  </div>
</template>

<script>
  import BreadCrumb from '../../../components/common/di-ding/common/bread-crumb'
  import {errorHandler} from '../../../utils/errorHandler'
  import InputTree from '../../../components/common/inputs/input-tree'
  import {pattern} from '../../../utils/regular'
  import {api} from '../../api/LadderControl'
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../components/Text/TextTitle'
  import ButtonCancel from '../../../components/Button/ButtonCancel'
  import ButtonConfirm from '../../../components/Button/ButtonConfirm'
  import {nSuccess} from '../../../utils/notice'
  import ButtonConfirmNext from '../../../components/Button/ButtonConfirmNext'
  // let a = document.getElementsByClassName()

  export default {
    components: {
      ButtonConfirmNext,
      ButtonConfirm,
      ButtonCancel,
      TextTitle,
      Breadcrumb,
      InputTree,
      BreadCrumb
    },
    name: 'elevator-modify',
    data () {
      return {
        config: {
          breadcrumb: [{
            value: '智慧梯控',
            name: 'ladder-device'
          }, {
            value: '电梯管理',
          }]
        },
        mainTitle: '修改电梯',
        subheading: '',
        name: '',
        buildingCode: '',
        buildingName: '',
        passAttribute: '0',
        relateGatewayCode: '',
        relateGatewayName: '',
        scene: '1',
        sceneList: [
          {
            code: '1',
            name: '园区场景'
          }, {
            code: '2',
            name: '楼栋场景'
          }
        ],
        startLevel: '',
        endLevel: '',
        useLift: false,
        authControl: false,
        controlTypeControl: false,
        passAttributeList: [
          {
            code: '0',
            name: '单双层'
          }, {
            code: '1',
            name: '单层'
          }, {
            code: '2',
            name: '双层'
          }
        ],
        buildingList: [],
        relateGatewayList: [],

        checkAll: false,
        checkedLevels: [],
        levelList: [],
        isIndeterminate: true,
      }
    },
    created () {
      this.getBuildingList()
      this.getLiftGatewayList()
      setTimeout(() => {
        this.getLiftDeviceByCode(this.$route.params.id)
      }, 50)
    },
    methods: {
      getLiftDeviceByCode (id) {
        api.getLiftDeviceByCode(id)
          .then(data => {
            if (data.authControl === 0) {
              this.authControl = false
            } else {
              this.authControl = true
            }
            if (data.useLift === '0') {
              this.useLift = false
            } else {
              this.useLift = true
            }
            if (data.controlType === '1') {
              this.controlTypeControl = true
            } else {
              this.controlTypeControl = false
            }
            let noControlerLevelArr = data.noControlerLevel.split(',')
            this.checkedLevels = []
            noControlerLevelArr.map(v => {
              this.checkedLevels.push(parseInt(v))
            })
            this.name = data.name
            this.buildingCode = data.buildingCode
            this.buildingName = data.buildingName
            this.passAttribute = data.passAttribute.toString()
            this.relateGatewayCode = data.relateGatewayCode
            this.relateGatewayName = data.relateGatewayName
            this.scene = data.scene
            this.startLevel = data.startLevel
            this.endLevel = data.endLevel
          })
          .catch(errorHandler('获取电梯数据失败'))
      },

      changeStartLevel (currentValue, oldValue) {
        if (oldValue === 1 && currentValue === 0) {
          this.startLevel = -1
        } else if (oldValue === -1 && currentValue === 0) {
          this.startLevel = 1
        }
      },

      changeEndLevel (currentValue, oldValue) {
        if (oldValue === 1 && currentValue === 0) {
          this.endLevel = -1
        } else if (oldValue === -1 && currentValue === 0) {
          this.endLevel = 1
        }
      },

      // 获取楼栋列表
      getBuildingList () {
        api.getBuildingList()
          .then(data => {
            this.buildingList = data
          })
          .catch(errorHandler('获取楼栋列表失败'))
      },
      // 获取设备列表
      getLiftGatewayList () {
        api.getLiftGatewayList()
          .then(data => {
            this.relateGatewayList = data
          })
          .catch(errorHandler('获取设备列表失败'))
      },

      handleCheckedCitiesChange(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.levelList.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.levelList.length;
      },

      getResponsiblePersonList (searchKey) {
        api.getResponsiblePerson(searchKey || '')
          .then(list => {
            list.forEach(it => {
              it._value = it.code
              it._label = `${it.name} / ${it.phone} / ${it.enterpriseName}`
            })
            this.responsiblePersonList = list
          })
      },
      remoteMethod (query) {
        this.getResponsiblePersonList(query)
      },
      confirm () {
        let obj = {
          code: this.$route.params.id,
          name: this.name,
          buildingCode: this.buildingCode,
          buildingName: '',
          passAttribute: this.passAttribute,
          relateGatewayCode: this.relateGatewayCode,
          relateGatewayName: '',
          scene: this.scene,
          startLevel: this.startLevel,
          endLevel: this.endLevel,
          useLift: '',
          controlType: '',
          authControl: '',
          noControlerLevel: ''
        }
        if (this.authControl) {
          obj.authControl = '1'
        } else {
          obj.authControl = '0'
        }
        if (this.checkedLevels) {
          if (this.checkedLevels.length > 0) {
            obj.noControlerLevel = this.checkedLevels.join(',')
          }
        }
        if (this.controlTypeControl) {
          obj.controlType = '1'
        } else {
          obj.controlType = '0'
        }
        if (this.useLift) {
          obj.useLift = '1'
        } else {
          obj.useLift = '0'
        }
        this.buildingList.map(v => {
          if (v.code === this.buildingCode) {
            obj.buildingName = v.name
          }
        })
        this.relateGatewayList.map(v => {
          if (v.deviceCode === this.relateGatewayCode) {
            obj.relateGatewayName = v.deviceName
          }
        })
        // this.responsiblePersonList.map(v => {
        //   if (v.code === this.responsiblePerson) {
        //     obj.responsiblePersonName = v._label
        //     obj.responsiblePersonCode = v.code
        //   }
        // })
        api.updateLiftDevice(obj)
          .then(() => {
            nSuccess('修改成功')
            this.strategyCenter()
          })
          .catch(errorHandler('添加电梯失败'))
      },
      strategyCenter () {
        this.$router.go(-1)
        // this.$router.push({
        //   path: '/access-control/device/center'
        // })
      }
    },
    watch: {
      startLevel (val) {
        if (this.endLevel > -99999 ) {
          let levelList = []
          for (let i = this.startLevel; i < this.endLevel + 1; i++) {
            if (i !== 0) {
              levelList.push(i)
            }
          }
          this.levelList = levelList
        }
      },

      endLevel (val) {
        if (this.startLevel > -99999 ) {
          let levelList = []
          for (let i = this.startLevel; i < this.endLevel + 1; i++) {
            if (i !== 0) {
              levelList.push(i)
            }
          }
          this.levelList = levelList
        }
      },

      authControl () {
        if (this.endLevel > -99999 && this.startLevel > -99999) {
          let levelList = []
          for (let i = this.startLevel; i < this.endLevel + 1; i++) {
            if (i !== 0) {
              levelList.push(i)
            }
          }
          this.levelList = levelList
        }
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
  }
  .form-line {
    margin: 20px 0;
  }
  .form-line>span {
    font-size: 12px;
    color: #97a8be;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 120px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin-top: 40px;
    display: flex;
    justify-content: space-between;
  }
</style>

<style lang="less">
  .elevator {
    .el-input-number--small .el-input__inner {
      text-align: left!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/Elevator/ElevatorModify.vue